import router from '../../router'
import { isbot } from 'isbot'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import BasketDataService from "./../../services/BasketDataService";

const version = require('./../../../package.json').version;
const callable = (process.env.VUE_APP_SHOP_CALLABLE) ? process.env.VUE_APP_SHOP_CALLABLE : "";
const base_url = "https://shop.ouderraadloppem.be/";

console.log(callable);

export default {
    namespaced: true,
    state: {
      isBot: isbot(navigator.userAgent),
      error: null,
      notifications: [],
      transactionRef: (localStorage.transactionRef) ? localStorage.transactionRef : null, 
      now: new Date(),
      version: version || '0',
      callable: callable,
      baseUrl: base_url
    },
    getters: {
        getError: (state) => state.error,
        appVersion: (state) => state.version 
    },
    mutations: {
        updateTransactionRef: (state, value) => (state.transactionRef = value),
        addNotification: (state, value) => (state.notifications.push(value)),
        removeNotification: (state, value) => (state.notifications = state.notifications.filter(item => item !== value)),
        setCartBusy(state, value = true) {
            if (state.cart === null) {
              state.cart = {}
            }
            state.cart['busy'] = value;
        }
    },
    actions: {
        async checkUser(context) {
            const auth = await getAuth();
            onAuthStateChanged(auth, async (firebaseUser) => {
                    console.log('Checking authentication onload', firebaseUser)
                    if ((!firebaseUser || firebaseUser.isAnonymous)) {
                        const newUser = {
                            uid: firebaseUser.uid,
                            displayName: firebaseUser.displayName,
                            emailVerified: firebaseUser.emailVerified,
                            anonymous: true
                        };
                        context.commit("setUser", newUser);
                        //context.commit("authenticated", firebaseUser.auth);
                        //UserDataService.createUser(newUser);
                    
                    }
            });
        },
        updateTransactionRef: async (context, value) => (context.commit('updateTransactionRef', value)),
        addNotification: async (context, value) => (context.commit('addNotification', value)),
        removeNotification: async (context, value) => (context.commit('removeNotification', value)),
        updateBasket: async (context, prodAndQuantity) => {
            context.commit('setCartBusy');
            console.log('prod & quantity', prodAndQuantity);
            /*
            const product_id = prodAndQuantity.product
            ? parseInt(prodAndQuantity.product.id)
            : prodAndQuantity.id;*/
      
            
            context.commit('addNotification',{title:'Update winkelmand',link:'#cart',content:'Klik hier om je winkelmandje te bekijken',type:'info', to: '#cart'});
        },
        removeFromBasket: async (context, product) => {
            context.commit('setCartBusy');
            const product_id = product.product.id;
      
            console.log(product_id);
            context.commit('addNotification',{title:'Product verwijdert uit winkelmand',link:'#cart',content:'',type:'info'});
          },
        add2Basket: async (context, prodAndQuantity) => {
            context.commit('setCartBusy')
            router.push('#cart')
            console.log('CART: prod', prodAndQuantity)
            let user_uid = context.state.user.uid;
       
            await BasketDataService.add2basket(user_uid,prodAndQuantity);

            //context.commit('addNotification',{title:'Product toegevoegd in winkelmand',link:'#cart',content:'Klik hier om je winkelmandje te bekijken',type:'info'});
        
        },

    }
}